import { render, staticRenderFns } from "./NewOnboarding.vue?vue&type=template&id=76746636&scoped=true&"
import script from "./NewOnboarding.vue?vue&type=script&lang=js&"
export * from "./NewOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./NewOnboarding.vue?vue&type=style&index=0&id=76746636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76746636",
  null
  
)

export default component.exports